import clamp from "./clamp";

export default function lerp(start, end, amt) {
	return (1 - amt) * start + amt * end;
}

export function lerpClamp(start, end, amt) {
	return lerp(start, end, clamp(amt, 0, 1));
}
